/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-02-21 10:44:26
 * @modify date 2020-02-21 10:44:26
 * @desc [description]
 */
<template>
  <div>
    <div id="basic_delete" class="modal custom submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#basic_delete"
            />
          </div>
          <div class="modal-body center pt-0">
            <img
              src="/static/images/icons/expiring_yellow.svg"
              class="info-icon"
            />
            <div class="sub-header">
              Are you sure you want to delete the selected user(s)?
            </div>
            <!-- <div class="sub-text">
              <div>
                Once deleted, you cannot recover the <br />
                information again.
              </div>
            </div> -->
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#basic_delete"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                data-dismiss="modal"
                data-target="#basic_delete"
                @click="$emit('deleteConfirmation')"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['deleteConfirmation', 'user'],
  data() {
    return {};
  }
};
</script>

<style scoped>
.modal-content {
  border-radius: 10px;
}
.modal-header {
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.modal-body {
  padding: 15px 35px;
}
.modal-footer {
  background: #fff;
  border-radius: 10px;
  border: 0;
  padding: 30px 35px;
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.info-icon {
  width: 58px;
  height: 58px;
}
.submit-popup .modal-body .sub-header {
  color: rgba(0, 0, 0, 0.7);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  padding-top: 25px;
  padding-bottom: 20px;
}
.submit-popup .modal-body .sub-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
  padding-bottom: 10px;
}
.submit-popup .modal-body {
  width: 92%;
  margin: auto;
}
.submit-popup .modal-footer {
  width: 90%;
  margin: auto;
  padding: 30px 15px;
}
.submit-popup .modal-dialog {
  width: 480px;
}
</style>
